import template from './additional-recipients.html';

export default {
  template: template,
  controller: 'ReportSubscriptionsAdditionalRecipientsController',
  bindings: {
    recipients: '<',
    applyRecipient: '&',
    removeRecipient: '&',
  },
};



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/components/additional-recipients/additional-recipients-component.js